import React from 'react';
import { useRAGStore } from '../store/ragStore';
import { Loader2 } from 'lucide-react';

const GlobalOperationIndicator: React.FC = () => {
  const { isOperationInProgress, currentOperation } = useRAGStore();

  if (!isOperationInProgress) {
    return null;
  }

  return (
    <div className="fixed top-4 right-4 z-50 bg-white border border-gray-200 rounded-lg shadow-lg p-4 max-w-sm">
      <div className="flex items-center space-x-3">
        <div className="flex-shrink-0">
          <Loader2 className="h-5 w-5 text-blue-600 animate-spin" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-gray-900">
            Operation in Progress
          </p>
          <p className="text-xs text-gray-500 truncate">
            {currentOperation || 'Processing...'}
          </p>
        </div>
      </div>
      
      {/* Progress bar animation */}
      <div className="mt-3 w-full bg-gray-200 rounded-full h-1">
        <div className="bg-blue-600 h-1 rounded-full animate-pulse" style={{ width: '100%' }}></div>
      </div>
    </div>
  );
};

export default GlobalOperationIndicator;
